module.exports = __webpack_public_path__ + "static/media/whiteLogo.cc5d559c.png";